import { MediaImage } from 'editor/src/store/design/types';

/** GAPI-61889: the opacity an image element renders with — absent, non-finite or out-of-range values are clamped to 0–1. */
export function getImageOpacity(element: Pick<MediaImage, 'opacity'> | undefined): number {
  const opacity = element?.opacity;
  if (typeof opacity !== 'number' || !Number.isFinite(opacity)) {
    return 1;
  }
  return Math.min(1, Math.max(0, opacity));
}

/**
 * The value to store on the element for a requested opacity: clamped to 0–1, rounded to 2 decimals (the control
 * works in whole percents), and `undefined` for fully opaque so an untouched-looking image keeps no extra key.
 */
export function toStoredImageOpacity(opacity: number): number | undefined {
  const value = getImageOpacity({ opacity: Math.round(opacity * 100) / 100 });
  return value === 1 ? undefined : value;
}

/** Opacity the canvas paints an image with: the sample/loading dimming (0.3) wins over the element's own opacity. */
export function getImageRenderOpacity(
  element: { type: string; sample?: boolean; opacity?: number },
  loading: boolean,
): number {
  if (element.sample || loading) {
    return 0.3;
  }
  return element.type === 'image' ? getImageOpacity(element) : 1;
}
